module.exports = __webpack_public_path__ + "img/icon2.db888e80.png";